// @flow

import * as React from 'react';

import type { Actions } from '../../../types';
import Row from '../../../components/Row';
import ActionsColumn from '../../../components/ActionsHeaderColumn';
import Separator from '../../../components/Separator';
import ActivateOrderAction from '../../../components/actions/ActivateOrderAction';
import ClearFiltersAction from '../../../components/actions/ClearFiltersAction'

type Props = {
  minHeight: string,
  clearCollectionAndResetChangedOrderItems: () => mixed
};

const ActionsOrganizer = (props: Actions & Props) => {
  const {
    ColumnsAction,
    CopyAction,
    ExportAction,
    RefreshAction,
    ResetAction,
    SaveViewAction,
    MultiSortAction,
    getGlobalDisabledState,
    isOneRowSelected,
    loading,
    onOrderActivated,
    orderActiveStatus,
    currentItem,
    clearCollectionAndResetChangedOrderItems,
    clearInternalFilters
  } = props;

  return (
    <Row minHeight={props.minHeight}>
      <ActionsColumn>
        <RefreshAction />
        <ExportAction />
      </ActionsColumn>

      <ActionsColumn>
        <CopyAction />
      </ActionsColumn>

      <Separator />

      <ActionsColumn>
        <SaveViewAction />
        <ResetAction />
      </ActionsColumn>

      <ActionsColumn>
        <ColumnsAction />
      </ActionsColumn>

      <Separator />

      <ActionsColumn>
        <ActivateOrderAction
          disabled={getGlobalDisabledState() || !isOneRowSelected || loading}
          onOrderActivated={onOrderActivated}
          orderActiveStatus={orderActiveStatus}
          item={currentItem}
          onMutationCompleted={clearCollectionAndResetChangedOrderItems}
        />
      </ActionsColumn>

      <Separator />

      <ActionsColumn>
        <ClearFiltersAction clearInternalFilters={clearInternalFilters} disabled={loading} />
      </ActionsColumn>

      <ActionsColumn>
        <MultiSortAction />
      </ActionsColumn>
    </Row>
  );
};

export default ActionsOrganizer;
